import React, { Component } from 'react'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import { withRouter } from 'react-router-dom'

class NavLeftList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      anchorEl: null,
    }
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  render() {
    const { anchorEl } = this.state

    return (
      <ul className="list-unstyled list-inline">
        <li className="list-inline-item">
          <div>
            <Menu
              id="header-long-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}>
              <MenuItem>
                <ListItemIcon>
                  <i className="material-icons">mail_outline</i>
                </ListItemIcon>
                <ListItemText
                  inset
                  primary="Here will be some kind text notifications"
                />
              </MenuItem>
            </Menu>
          </div>
        </li>
      </ul>
    )
  }
}

export default withRouter(NavLeftList)
